const numbers = require('investira.sdk').numbers;
const { toDate } = require('investira.sdk').dates;
const { isDate } = require('investira.sdk').validators;

/*
 * 1986-02-28 PLANO CRUZADO     CRUZEIRO(Cr$) 1000 = 1 CRUZADO(Cz$)
 * 1986-11-21 PLANO CRUZADO II
 * 1987-06-12 PLANO BRESSER
 * 1989-01-16 PLANO VERÃO       CRUZADO(Cz$) 1000 = 1 CRUZADO NOVO(NCz$)
 * 1990-03-15 PLANO COLLOR I    CRUZADO NOVO(NCz$) 1 = 1 CRUZEIRO(Cr$) (Não houver corte de zeros)
 * 1991-01-31 PLANO COLLOR II
 * 1993-08-01 PLANO REAL        CRUZEIRO(Cr$) 1000 = 1 CRUZEIRO REAL(CR$)
 * 1994-07-01 PLANO REAL        CRUZEIRO REAL(CR$) 2750 = 1 REAL(R$)
 */

const MOEDAS = {
    BRA: [
        { data: toDate('1970-05-15'), fator: 1000, moeda: { simbolo: 'Cr$', nome: 'Cruzeiro' } }, //CRUZEIRO NOVO(Cr$) 1000 = 1 CRUZEIRO(Cz$)
        { data: toDate('1986-03-03'), fator: 1000, moeda: { simbolo: 'Cz$', nome: 'Cruzado' } }, //CRUZEIRO(Cr$) 1000 = 1 CRUZADO(Cz$)
        { data: toDate('1989-01-16'), fator: 1000, moeda: { simbolo: 'NCz$', nome: 'Cruzado Novo' } }, //CRUZADO(Cz$) 1000 = 1 CRUZADO NOVO(NCz$)
        { data: toDate('1990-03-15'), fator: 1, moeda: { simbolo: 'Cr$', nome: 'Cruzeiro' } }, //CRUZADO NOVO(NCz$) 1 = 1 CRUZEIRO(Cr$) (Não houver corte de zeros)
        { data: toDate('1993-08-02'), fator: 1000, moeda: { simbolo: 'CR$', nome: 'Cruzeiro Real' } }, //CRUZEIRO(Cr$) 1000 = 1 CRUZEIRO REAL(CR$)
        { data: toDate('1994-07-01'), fator: 2750, moeda: { simbolo: 'R$', nome: 'Real' } } //CRUZEIRO REAL(CR$) 2750 = 1 REAL(R$)
    ]
};

const operacoes = {
    /**
     * Retorna se operação será uma realização
     *
     * @param {object} pParams {{atual:{quantidade},operacao:{quantidade}}
     * @returns {boolean}
     */
    isRealizacao: pParams => {
        return Math.sign(pParams.atual.quantidade) !== Math.sign(pParams.operacao.quantidade);
    },

    /**
     * Retorna a quantidade Realizada
     *
     * @param {object} pParams {{atual:{quantidade},operacao:{quantidade}}
     * @returns {number}
     */
    quantidadeRealizada: pParams => {
        if (operacoes.isRealizacao(pParams)) {
            if (Math.abs(pParams.atual.quantidade) < Math.abs(pParams.operacao.quantidade)) {
                return Math.sign(pParams.operacao.quantidade) * Math.abs(pParams.atual.quantidade);
            } else {
                return Math.sign(pParams.operacao.quantidade) * Math.abs(pParams.operacao.quantidade);
            }
        } else {
            return 0;
        }
    },

    /**
     * Retorna preço médio utilizando média ponderada
     *
     * @param {object} pParams {atual:{pu, quantidade}, operacao:{pu, quantidade}}
     * @return {number} Preço médio
     */
    puMedio: pParams => {
        if (pParams.atual.quantidade == 0) {
            return pParams.operacao.pu;
        }
        let xSaldo = numbers.add(pParams.atual.quantidade, pParams.operacao.quantidade);
        //Retorna zero se posição for zerada
        if (xSaldo === 0) {
            return 0;
        }
        //Retorna pu operado quando o novo saldo mudar de sinal
        if (Math.sign(xSaldo) !== Math.sign(pParams.atual.quantidade)) {
            return pParams.operacao.pu;
        } else if (!operacoes.isRealizacao(pParams)) {
            // Preço médio deve ser calcula quando:
            // Ocorrer uma nova movimentação com o mesmo sinal da posição ou
            // for excluido uma movimentação que mudou a preço médio.
            return numbers.weightedMean([pParams.atual.pu, pParams.operacao.pu], [pParams.atual.quantidade, pParams.operacao.quantidade]);
        }
        return pParams.atual.pu;
    },

    /**
     * Retorna financeiro com todas as casas
     *
     * @param {object} pParams {quantidade, pu, lote}
     * @return {number} financeiro
     */
    financeiro: pParams => {
        if (pParams.quantidade === 0 || pParams.pu === 0) {
            return 0;
        }
        let xFinanceiro = numbers.mul(numbers.div(pParams.quantidade, pParams.lote), pParams.pu);
        return xFinanceiro;
    },
    /**
     * Retorna pu com todas as casas
     *
     * @param {object} pParams {quantidade, financeiro, lote}
     * @return {number} pu
     */
    pu: pParams => {
        if (pParams.quantidade === 0 || pParams.financeiro === 0) {
            return 0;
        }
        let xPu = numbers.trunc(numbers.div(pParams.financeiro, numbers.div(pParams.quantidade, pParams.lote)), 14);
        return xPu;
    },

    /**
     * Retorna quantidade com todas as casas
     *
     * @param {object} pParams {pu, financeiro, lote}
     * @return {number} quantidade
     */
    quantidade: pParams => {
        if (pParams.financero === 0 || pParams.pu === 0) {
            return 0;
        }
        let xQuantidade = numbers.mul(numbers.div(pParams.financeiro, pParams.pu), pParams.lote);
        return xQuantidade;
    },

    /**
     *  Converte de uma moeda para a outra em função de planos econômicos
     *
     * @param {number} pValorBase
     * @param {Date} pDataBase
     * @param {Date} pDataAlvo
     * @return {object}
     */
    converteMoeda: (pPais, pValorBase, pDataBase, pDataAlvo = toDate()) => {
        const xResponse = {
            base: {
                data: pDataBase,
                valor: pValorBase,
                moeda: {}
            },
            alvo: {
                data: pDataAlvo,
                valor: pValorBase,
                moeda: {}
            }
        };
        if (!MOEDAS[pPais]) {
            return xResponse;
        }
        if (!isDate(pDataBase)) {
            console.error('ConverteMoeda: Data base não é uma data válida');
            return false;
        }
        let xI_base = null;
        let xI_alvo = MOEDAS[pPais].length - 1;
        for (let i = 0; i < MOEDAS[pPais].length; i++) {
            if (MOEDAS[pPais][i].data > pDataAlvo) {
                break;
            }
            if (MOEDAS[pPais][i].data.getTime() <= pDataBase.getTime()) {
                //Salva qual a moeda base e alvo mínima
                xI_base = i;
                xI_alvo = i;
                continue;
            }
            //Efetua ajuste do valor
            xResponse.alvo.valor /= MOEDAS[pPais][i].fator;
            //Salva qual a moeda alvo foi utilizada
            xI_alvo = i;
        }
        xResponse.base.moeda = MOEDAS[pPais][xI_base].moeda;
        xResponse.alvo.moeda = MOEDAS[pPais][xI_alvo].moeda;
        return xResponse;
    },

    /**
     *  Converte de uma moeda para a outra em função de planos econômicos
     *
     * @param {number} pValorBase
     * @param {Date} pDataBase
     * @param {Date} pDataAlvo
     * @return {object}
     */
    converteMoedaBRA: (pValorBase, pDataBase, pDataAlvo = toDate()) => {
        return operacoes.converteMoeda('BRA', pValorBase, pDataBase, pDataAlvo);
    }
};

module.exports = operacoes;
